/* tslint:disable */
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import { HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {FormsModule} from '@angular/forms';

import {RouterModule} from '@angular/router';

import {DatePipe} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxSpinnerModule} from "ngx-spinner";
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {UserService} from "./atlas/user-management/user.service";
import { MAT_DATE_LOCALE } from '@angular/material/core';


@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        NgxSpinnerModule,
        BrowserAnimationsModule,
    ],
    providers: [
        DatePipe,
        UserService,
        { provide: MAT_DATE_LOCALE, useValue: navigator.language || 'en-GB'} // Dynamically set locale

    ],
    exports: [
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
